import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import { shouldRedirectToCognitoLogin, redirectToCognitoLogin } from './utils/cognitoAuth';
// i18n
import './i18n';
// Theme and style
import '@repo/zolintra-ui/styles/theme.css';
import '@repo/zolintra-ui/styles/reset.css';
import '@repo/zolintra-ui/styles/fonts.css';
import 'react-toastify/dist/ReactToastify.css';

if (shouldRedirectToCognitoLogin()) {
  redirectToCognitoLogin();
} else {
  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
